import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '../../common/api/createBaseQuery';

import { IAppContext } from '../../common/types/applicationContext';
import {
  fetchPublicB2cV1GetOffers,
  TPublicB2cV1GetOffersRequest,
  TPublicB2cV1GetOffersResponse_1 as TPublicB2cV1GetOffersResponse,
} from '../../common/repositories/mortgage-broker-calculator/b2c/v1/get-offers';

import {
  fetchPublicB2cV2GetOffers,
  TPublicB2cV2GetOffersRequest,
  TPublicB2cV2GetOffersResponse_1 as TPublicB2cV2GetOffersResponse,
} from '../../common/repositories/mortgage-broker-calculator/b2c/v2/get-offers';

export type TMortgageMiniCalculatorApiEndpoints = keyof typeof mortgageMiniCalculatorApi.endpoints;
export let mortgageMiniCalculatorApi: ReturnType<typeof createMortgageMiniCalculatorApi>;

export const createMortgageMiniCalculatorApi = (ctx: IAppContext) => {
  const newApi = createApi({
    reducerPath: 'mortgageMiniCalculatorApi',
    baseQuery: createBaseQuery(ctx),
    endpoints: builder => ({
      getOffers: builder.query<
        TPublicB2cV1GetOffersResponse | TPublicB2cV2GetOffersResponse,
        TPublicB2cV1GetOffersRequest | TPublicB2cV2GetOffersRequest
      >({
        query: parameters => {
          // Для v2 API нужны objectType и realEstate
          if (
            'objectType' in parameters &&
            parameters.objectType &&
            'realEstate' in parameters &&
            parameters.realEstate
          ) {
            return {
              parameters,
              fetchFunction: fetchPublicB2cV2GetOffers,
              loggerInfo: {
                description: 'Fetching offers for mini calculator (v2)',
                degradation: 'Critical error display, listing unavailable (v2)',
              },
            };
          } else {
            // TODO: избавиться от данного условия https://jira.cian.tech/browse/CD-236273
            return {
              parameters,
              fetchFunction: fetchPublicB2cV1GetOffers,
              loggerInfo: {
                description: 'Fetching offers for mini calculator (v1)',
                degradation: 'Critical error display, listing unavailable (v1)',
              },
            };
          }
        },
      }),
    }),
  });

  mortgageMiniCalculatorApi = newApi;

  return newApi;
};
